import { render, staticRenderFns } from "./main-section-primary.vue?vue&type=template&id=000bf8a7&scoped=true&"
import script from "./main-section-primary.vue?vue&type=script&lang=js&"
export * from "./main-section-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000bf8a7",
  null
  
)

export default component.exports